import { mapActions, mapMutations } from 'vuex'

export default {
  ...mapActions(['updateSettings']),
  ...mapMutations([
    'setSettingsNotifyToggle',
    'setSettingsNotifySendToggle',
    'setSettingsNotifyPushAppToggle',
    'setSettingsNotifyPushWebToggle',
    'setSettingsIntegrationOffline'
  ]),
  doToogleNotifySettings (key) {
    this.setSettingsNotifyToggle(key)
    this.updateSettings()
  },
  doToogleNotifySendSettings (key) {
    this.setSettingsNotifySendToggle(key)
    this.updateSettings()
  },
  doToogleNotifyPushAppSettings () {
    this.setSettingsNotifyPushAppToggle()
    this.updateSettings()
  },
  doToogleNotifyPushWebSettings () {
    this.setSettingsNotifyPushWebToggle()
    this.updateSettings()
  },
  // Integração de dados
  doToogleIntegrationSettings (key) {
    this.setSettingsIntegrationOffline(key)
    this.updateSettings()
  }
}



// WEBPACK FOOTER //
// ./src/layout/headers/menu/config/resources/methods.js